export interface Addon {
  code: string;
  name: string;
  monthlyCost: number;
  addonType: 'DEFAULT' | 'EXTRA';
}

export interface Package {
  code: string;
  name: string;
  description: string;
  monthlyFee: number;
  addons: Addon[];
}

export interface Breakdown {
  grossSalary: number;
  employeeBenefits: number;
  localTaxes: number;
  eorFee: number;
  eorBaseFee: number;
  addonsCost: number;
  total: number;
}

export interface EstimateData {
  package: { code: string; name: string; monthlyFee: number };
  addons: Addon[];
  breakdown: Breakdown;
  period: string;
}

export function formatCurrency(value: number): string {
  return Math.round(value).toLocaleString('en-IE') + '€';
}
